import { useMemo } from "react"
import { formatObject } from "../../../../features/dataFormatFunctions/formatObject"
import { useAppSelector } from "../../../../stateManagement/hooks/redux"

type MapTooltipData = Record<string, any> | null | undefined

export function formatMapTooltipDisplayData<T extends MapTooltipData>(data: T): T {
    return formatObject(data) as T
}

export function useMapTooltipDisplayData<T extends Record<string, any> = Record<string, any>>() {
    const data = useAppSelector(state => state.mapTooltip.data) as T
    const displayData = useMemo(() => formatMapTooltipDisplayData(data), [data]) as T

    return { data, displayData }
}
